// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"37805364","376":"5a26bd41","622":"1b5231c6","896":"35ca72a4"}[chunkId] + ".chunk.css";
};